<template>
    <div class="setting">
        <el-tabs v-model="activeName">
            <el-tab-pane label="CEF会员" name="first">
                <vipSetting type="cef"></vipSetting>
            </el-tab-pane>
            <el-tab-pane label="理事会员">
                <vipSetting type="committee"></vipSetting>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import request from '@/utils/request'
    import vipSetting from './components/vipSetting'

    export default {
      name: 'setting',
      components: {
        vipSetting
      },
      data () {
        return {
          activeName: 'first'
      }
  },
  created () {
    this.initData()
},
methods: {
}
}
</script>
<style lang="scss" scoped>
.setting {
}
</style>



// WEBPACK FOOTER //
// src/views/vip/setting.vue